<template>
    <div>
        <header>
            <h1> Completed {{selected_projects_tasks.length}} tasks in {{range?year:'last twelve months'}}</h1>
            <div class="text-right">
                <select class="projects" v-model="selected_projects" multiple>
                    <option v-for="project in projects" :value="project">{{project}}</option>
                </select>
                <br />
                Projects:
                <button v-on:click="selected_projects=projects">All</button>
                <button v-on:click="selected_projects=[]">None</button>
                &nbsp;
                Range:
                <button v-on:click="range=LAST_TWELVE_MONTHS_RANGE">Last 12 months</button> or
                <input name="year" type="numeric" placeholder="Year" v-model="year" />&nbsp;
                <button v-on:click="range=YEAR_RANGE">This Year</button>
            </div>
        </header>
        <Calendar :tasks="selected_projects_tasks" :range="range" :year="year" />
    </div>
</template>

<script>
 import axios from 'axios'
 import Calendar from './Calendar.vue'

 export default {
     name: 'HelloWorld',
     components: { Calendar },
     props: {
         msg: String
     },
     data: function() {
         return{
             cells: [],
             year: new Date().getFullYear(),
             range: 0,
             projects: [],
             selected_projects: [],
         }
     },
     computed: {
         LAST_TWELVE_MONTHS_RANGE: function() {
             return 0;
         },
         YEAR_RANGE: function() {
             return 1
         },
         tasks: function() {
             return this.parseRows(this.cells)
         },
         selected_projects_tasks: function() {
             return this.tasks.filter( (e) => {
                 return this.selected_projects.indexOf(e.project)!=-1
             })
         }
     },
     methods: {
         addProject(project){
             if(this.projects.indexOf(project) === -1) {
                 this.projects.push(project)
             }
         },
         getSheetDataUrl: function(spreadsheet_id) {
             let api='https://spreadsheets.google.com/feeds/cells/'+spreadsheet_id+'/1/public/full?alt=json'
             return api
         },
         parseRows: function() {
             let tasks = []
             let cells = this.cells
             for(let i=0; i<cells.length; i+=6) {
                 //tags cell is optional so some rows may only contain 5 cells instead of 6
                 this.addProject(cells[i+1].content.$t)
                 if(cells[i+3].title.$t[0] == "D")
                     {
                         tasks.push({
                             title: cells[i].content.$t,
                             project: cells[i+1].content.$t,
                             date: cells[i+2].content.$t,
                             tags: cells[i+3].content.$t,
                             priority: cells[i+4].content.$t,
                             url: cells[i+5].content.$t
                         })
                     }
                 else
                     {
                         tasks.push({
                             title: cells[i].content.$t,
                             project: cells[i+1].content.$t,
                             date: cells[i+2].content.$t,
                             tags: "",
                             priority: cells[i+3].content.$t,
                             url: cells[i+4].content.$t
                         })
                         i--;
                     }
             }

             return tasks;
         }
     },
     created: function() {
         let api = this.getSheetDataUrl('1t_A9p-fKdFGQXoyeCQzcZmwknTDf6uydLQRjoG5qep4')
         axios.get(api).then( response => {
             this.cells = response.data.feed.entry;
         })
     }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header{
    display: grid;
    grid-template-columns: auto auto;
    background: #DDD;
    padding: 1em;
}
.text-right{
    text-align: right;
}

select.projects{
    width:100%;
}
@media screen and (max-width: 480px) {
    header{
        grid-template-columns: 1fr;
    }
}
</style>
